/**
 * Describes different variants of SongListItems that can appear across the application.
 */

export enum SongListItemVariant {
  Library = 'library',
  Recommendation = 'recommendation',
  /**
   * Default means that no additional configuration is needed for the component.
   */
  Default = 'default',
}
